var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9446 0C4.9058 0 0 3.45478 0 9.77878C0 16.8149 8.2555 24.3742 17.6757 33.4654C18.0443 33.8224 18.5231 34 19 34C19.4769 34 19.9557 33.8224 20.3243 33.4654C29.7806 24.3402 38 16.8168 38 9.77878C38 3.44533 33.098 0.0170001 28.0649 0.0170001C24.5765 0.0170001 21.1375 1.65278 19 4.84122C16.853 1.63767 13.4235 0 9.9446 0ZM9.9446 2.83333C13.7256 2.83522 16.0284 5.389 17.8391 7.93333C18.1051 8.30733 18.5383 8.53022 19 8.53211C19.4617 8.53211 19.8949 8.31111 20.1628 7.939C21.9773 5.40978 24.3238 2.85033 28.0649 2.85033C31.4773 2.85033 35.15 5.01878 35.15 9.77878C35.15 14.824 29.6761 20.4944 19 30.7964C8.6374 20.8137 2.85 14.9506 2.85 9.77878C2.85 7.65378 3.5891 5.87067 4.9856 4.62778C6.2643 3.48689 8.0731 2.83333 9.9446 2.83333Z",
    fill: "url(#paint0_linear_79_1652)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_1652",
    x1: 50.8737,
    y1: -20.8091,
    x2: -22.4248,
    y2: -13.2057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45668,
    stopColor: "#FF778E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B97AFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.1c6e8a5e4359d284b2ae65661c05e901.svg";
export { ForwardRef as ReactComponent };